import { useNav } from "@/src/hooks";
import { HamburgerIcon } from "@/src/icons";
import { ConnectButton } from "./connectButton";
import { ThemeToggle } from "./themeToggle";

export const Header = () => {
  const { onToggle } = useNav();

  return (
    <header className="flex justify-between items-center py-4 px-4 sm:px-6 max-w-[98rem] m-auto w-full border-b border-border/50">
      <div>
        <button
          id="modal-button"
          className="lg:hidden p-2.5 bg-secondary border border-border rounded-xl flex items-center hover:bg-muted transition-colors"
          onClick={(e) => {
            e.stopPropagation();
            onToggle();
          }}
        >
          <HamburgerIcon className="w-6 h-5 text-foreground" />
        </button>
      </div>

      <div className="flex items-center gap-2 sm:gap-3">
        <ThemeToggle />
        <ConnectButton />
      </div>
    </header>
  );
};
